import React, { useEffect, useState } from "react";
import { ChatState } from "../../Context/ChatProvider";
import { Box, Button, Stack, Text, useToast } from "@chakra-ui/react";
import axios from "axios";
import { API_URL } from "../../API_CALL/api-url";
import { AddIcon } from "@chakra-ui/icons";
import ChatLoading from "../chat/ChatLoading";
import { getSender } from "../../config/ChatLogics";
import GroupChatModal from "./GroupChatModal";

const MyChats = ({ fetchAgain }) => {
  const [loggedUser, setLoggedUser] = useState();
  const { user, selectedChat, setSelectedChat, chats, setChats } = ChatState();

  const toast = useToast();

  const fetchChat = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };
      const { data } = await axios.get(`${API_URL}/api/chat`, config);
      console.log(data);
      setChats(data);
    } catch (error) {
      toast({
        title: "Error Occured!",
        description: "Failed to Load the chats",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  };

  useEffect(() => {
    if (!JSON.parse(localStorage.getItem("userInfo"))) {
      return
    }
    setLoggedUser(JSON.parse(localStorage.getItem("userInfo")));
    fetchChat();
  }, [fetchAgain]);

  return (
    <>
      <Box
        display={{ base: selectedChat ? "none" : "flex", md: "flex" }}
        flexDirection='column'
        alignItems='center'
        p={3}
        background='white'
        width={{ base: "100%", md: "31%" }}
        borderRadius='lg'
        borderWidth='1px'
      >
        <Box
          paddingBottom={3}
          px={3}
          fontSize={{ base: "28px", md: "30px" }}
          fontFamily='Work sans'
          display='flex'
          width='100%'
          justifyContent='space-between'
          alignItems='center'
        >
          My Chats
          <GroupChatModal>
            <Button
              display='flex'
              fontSize={{ base: "17px", md: "10px", lg: "17px" }}
              rightIcon={<AddIcon />}
            >
              New Group Chat
            </Button>
          </GroupChatModal>
        </Box>
        <Box
          display='flex'
          flexDir='column'
          padding={3}
          background='#F8F8F8'
          width='100%'
          height='100%'
          borderRadius='lg'
          overflowY='hidden'
        >
          {chats ? (
            <Stack overflowY='scroll'>
              {chats.map((chat) => (
                <Box
                  onClick={() => setSelectedChat(chat)}
                  cursor='pointer'
                  background={selectedChat === chat ? "#38B2AC" : "#E8E8E8"}
                  color={selectedChat === chat ? "white" : "black"}
                  px={3}
                  py={2}
                  borderRadius='lg'
                  key={chat._id}
                >
                  <Text>
                    {!chat.isGroupChat
                      ? getSender(loggedUser, chat.users)
                      : chat.chatName}
                  </Text>
                </Box>
              ))}
            </Stack>
          ) : (
            <ChatLoading />
          )}
        </Box>
      </Box>
    </>
  );
};

export default MyChats;
